/**
 * Strips HTML tags from a rich-text fragment, returning plain text.
 *
 * Post/resource titles can now contain inline formatting (bold, italic,
 * link, superscript, subscript) applied from the editor's title field.
 * That rich HTML is only ever rendered on the actual H1 heading of the
 * post's own detail page — everywhere else a title is treated as plain
 * text (browser tab <title>, SEO metaTitle/og:title fallback, JSON-LD
 * headline, breadcrumbs, sitemap, admin post list, related-post cards,
 * search) MUST go through this first, or literal tags would leak into
 * those surfaces.
 */
export function stripHtml(html: string): string {
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#0?39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}
